import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["jsLazy", "forceRenderPreview", "fit", "hotspot", "crop", "options", "config", "asset", "__typename"],
  _excluded2 = ["preview"],
  _excluded3 = ["preview"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as r, jsxs as x, Fragment as b } from "react/jsx-runtime";
import { useMemo as j, useState as P, useRef as C, useCallback as N, useEffect as p } from "react";
import F from "@sanity/image-url";
import { useSanityClient as L } from "../useSanityClient.js";
import { i as R } from "../checks-C6AyTTQ0.js";
import { t as _, p as z, b as A, d as k } from "../utils-NCUO6j8v.js";
import { c as q } from "../clsx-OuTLNxxd.js";
const E = e => {
    const {
        hotspot: t,
        width: s,
        height: a,
        fit: i
      } = e,
      n = L({
        useCdn: !0
      }),
      u = F(n),
      h = j(() => {
        if (t) return {
          objectPosition: [t.x, t.y].map(l => (l * 100).toFixed(2) + "%").join(" ")
        };
      }, [t]),
      o = _(e);
    if (!R(o)) return;
    const S = z(o._id).format,
      c = A(u, o, {
        width: s,
        height: a,
        fit: i
      }),
      f = k(u, o, {
        width: s,
        height: a,
        fit: i
      });
    return {
      imageStyle: h,
      width: s,
      height: a,
      srcSet: f,
      src: c,
      format: S
    };
  },
  O = e => {
    var _e$asset$metadata;
    const {
        jsLazy: t = !1,
        forceRenderPreview: s = !1,
        fit: a = "crop",
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        hotspot: i,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        crop: n,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        options: u,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        config: h,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        asset: o,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        __typename: S
      } = e,
      c = _objectWithoutProperties(e, _excluded),
      f = a == "crop" ? "max" : "clip",
      {
        imageStyle: l,
        width: d,
        height: g,
        srcSet: w,
        src: y,
        format: I
      } = E(_objectSpread(_objectSpread({}, e), {}, {
        fit: f
      })) || {};
    if (I === "svg") return /* @__PURE__ */r("img", _objectSpread({
      src: y
    }, e));
    const m = (_e$asset$metadata = e.asset.metadata) === null || _e$asset$metadata === void 0 ? void 0 : _e$asset$metadata.preview;
    return s ? m ? /* @__PURE__ */r(v, _objectSpread({
      preview: m,
      width: d,
      height: g
    }, c)) : null : t ? /* @__PURE__ */r("img", _objectSpread({
      src: m,
      "data-src": y,
      "data-src-set": w,
      width: d,
      height: g,
      style: l,
      className: q("js-lazy-load", e.className)
    }, c)) : /* @__PURE__ */r(m ? M : "img", _objectSpread({
      preview: m,
      style: l,
      width: d,
      height: g,
      src: y,
      srcSet: w
    }, c));
  },
  v = _ref => {
    let {
        preview: e
      } = _ref,
      t = _objectWithoutProperties(_ref, _excluded2);
    return /* @__PURE__ */r("img", {
      src: e,
      alt: t.alt,
      id: t.id,
      className: t.className,
      style: t.style,
      width: t.width,
      height: t.height,
      "data-lqip": !0
    });
  },
  M = _ref2 => {
    let {
        preview: e
      } = _ref2,
      t = _objectWithoutProperties(_ref2, _excluded3);
    const [s, a] = P(!1),
      i = C(null),
      n = N(() => {
        a(!0);
      }, []);
    return p(() => {
      i.current && i.current.complete && n();
    }, []), /* @__PURE__ */x(b, {
      children: [!s && /* @__PURE__ */r(v, _objectSpread({
        preview: e
      }, t)), /* @__PURE__ */r("img", _objectSpread({
        ref: i,
        onLoad: n,
        "data-loading": s ? null : !0
      }, t))]
    });
  };
export { O as default };